import React from 'react';
import './SoftwareDevelopment.css';
import Design from '../components/Design';

const SoftwareDevelopment = () => {
  return (
    <div>
      <Design />
    </div>
  );
};

export default SoftwareDevelopment;
